import { useRef, useEffect, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TabPanel as AriaTabPanel } from 'react-aria-components';
import RegionsList from '@pages/sales-network/shared/RegionsList';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';



interface TabPanelProps {
	country: AppLanguageCode,
	children: ReactNode,
	selectedRegion: string,
}


const TabPanel = (props: TabPanelProps) => {
	const { country, children, selectedRegion } = props;
	const { t } = useTranslation('web');

	const footerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (selectedRegion !== '') {
			setTimeout(() => footerRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ selectedRegion, footerRef ]);
	
	
	return (
		<AriaTabPanel id={country}>
			<div className='info-item'>
				<p>{t('pages.salesNetwork.infoMessage')}</p>
			</div>

			{children}

			<RegionsList
				selectedRegion={selectedRegion}
				country={country} />

			<div className='sales-network-footer' ref={footerRef}></div>
		</AriaTabPanel>
	);
};

export default TabPanel;